var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"h-[16px] min-w-[16px] absolute top-0 right-0 rounded-full bg-red text-white flex justify-center items-center text-12 leading-3 font-bold p-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }